'use client'
import { IconDownSmall } from 'icons/components/IconDownSmall'
import { IconUpSmall } from 'icons/components/IconUpSmall'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { type ForwardedRef, forwardRef } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { AccountLink } from '../../AccountLink/AccountLink'
import { ACCOUNT_MENU_ID } from '../../constants/accountMenu'
import { useAccountLink } from '../../hooks/useAccountLink'
import styles from './AccountIcon.module.css'

type AccountIconProps = Readonly<{
	isExpanded?: boolean
	onClick?: () => void
}>

export const AccountIcon = forwardRef<HTMLAnchorElement, AccountIconProps>(
	(
		{ isExpanded = false, onClick }: Readonly<AccountIconProps>,
		ref: ForwardedRef<HTMLAnchorElement>
	) => {
		const { isLargeOrGreater } = useResponsive()
		const { accessibilityText } = useAccountLink()
		const { t } = useLabels()

		return (
			<div className={styles.userLinkContainer}>
				<AccountLink ref={ref} />
				{isLargeOrGreater && (
					<button
						type='button'
						className={styles.accessibilityButton}
						onClick={onClick}
						aria-label={t(accessibilityText)}
						aria-expanded={isExpanded}
						aria-controls={ACCOUNT_MENU_ID}
					>
						{isExpanded ? (
							<IconUpSmall width={20} height={20} />
						) : (
							<IconDownSmall width={20} height={20} />
						)}
					</button>
				)}
			</div>
		)
	}
)

AccountIcon.displayName = 'AccountIcon'
